import React from 'react';
import { Image, Typography, Space, Button, Tooltip } from 'antd';
import { DownloadOutlined, FileImageOutlined, FileTextOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { formatImg } from '../utils/functions'
const { Text } = Typography;

/**
 * 渲染文件列表，支持图片、视频预览和其他文件下载
 * @param {string} filePaths - 以逗号分隔的文件路径字符串
 * @returns {JSX.Element} 渲染后的文件列表
 */
const renderFileList = (filePaths, wh=30) => {
    let pathArray = [];

    if (Array.isArray(filePaths)) {
        pathArray = filePaths;
    } else if (typeof filePaths === 'string' && filePaths.trim()) {
        pathArray = filePaths.split(',');
    }
    const validPaths = pathArray
        .map(raw => {
            if (typeof raw !== 'string') return null;
            const trimmed = raw.trim();
            if (!trimmed || trimmed === '0') return null;
            return formatImg(trimmed);
        })
        .filter(Boolean);
    if (validPaths.length === 0) {
        return <Text type="secondary">无</Text>;
    }


    const fileList = validPaths;
    // 3. 定义文件类型判断和渲染逻辑
    const getFileIcon = (fileType) => {
        if (fileType.startsWith('image/')) return <FileImageOutlined />;
        if (fileType.startsWith('video/')) return <VideoCameraOutlined />;
        return <FileTextOutlined />;
    };

    const renderFileItem = (filePath) => {
        // 从路径中提取文件名作为下载时的默认名称
        const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);

        // 简单判断文件类型 (更可靠的方式是后端返回MIME类型)
        const fileExtension = fileName.split('.').pop()?.toLowerCase();
        let fileType = 'application/octet-stream'; // 默认二进制流

        if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension)) {
            fileType = 'image';
        } else if (['mp4', 'webm', 'ogg'].includes(fileExtension)) {
            fileType = 'video';
        } else if (['pdf'].includes(fileExtension)) {
            fileType = 'application/pdf';
        } else if (['doc', 'docx'].includes(fileExtension)) {
            fileType = 'application/msword';
        } else if (['xls', 'xlsx'].includes(fileExtension)) {
            fileType = 'application/vnd.ms-excel';
        }

        // 根据文件类型渲染不同的组件
        if (fileType === 'image') {
            return (
                <Image
                    width="100%"
                    src={filePath}
                    preview={{ title: fileName }}
                    style={{ objectFit: 'cover', borderRadius: 4, margin: '0 8px 8px 0' }}
                />
            );
        } else if (fileType === 'video') {
            return (
                <div style={{ width:`${wh}px`, height:`${wh}px`, margin: '0 8px 8px 0',cursor:'pointer', position:'relative' }}>
                    <video
                        width="100%"
                        controls
                        src={filePath}
                        style={{ display: 'block' }}
                        poster={`${filePath}?t=0.1`} // 尝试用视频第一帧作为封面（需后端支持）
                    >
                        您的浏览器不支持视频播放，请下载查看
                    </video>
                    <div onClick={() => {
                            const link = document.createElement('a');
                            link.href = filePath;
                            link.target = "_blank"
                            link.click();
                        }}
                        style={{ width: '100%', height:'100%', cursor:'pointer', position:'absolute', left:0, top:0, zIndex:10, }}
                    >
                        
                    </div>
                </div>
            );
        } else {
            // 对于其他文件类型，提供下载按钮
            return (
                <Button
                        style={{
                            width:`${wh}px`,
                            height:`${wh}px`,
                            padding: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            whiteSpace: 'normal', // 允许文字换行
                            lineHeight: '1.2', // 调整行高避免文字重叠
                            wordWrap: 'break-word', // 强制换行
                            overflow: 'hidden', // 超出部分隐藏
                            textOverflow: 'ellipsis', // 文字超出显示省略号
                        }}

                        onClick={() => {
                            const link = document.createElement('a');
                            link.href = filePath;
                            link.download = filePath;
                            link.target = "_blank"
                            link.click();
                        }}

                    >
                        {/* 图标 */}
                        {getFileIcon(fileType)}
                        {/* 文件名 */}
                        <span style={{
                            maxWidth: `${wh}px`, // 限制最大宽度，留出边距
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontSize: '12px', // 缩小字体适应小尺寸
                            textAlign: 'center', // 文字居中
                        }}>
                            {fileName}
                        </span>
                    </Button>
            );
        }
    };

    // 4. 渲染所有文件
    return (
        <div style={{
            display: 'flex',
            flexWrap: 'wrap', // 允许换行
            gap: '8px', // 使用 gap 替代 margin 来管理间距
            alignItems: 'flex-start', // 子项顶部对齐
            width: '100%', // 父容器宽度为100%，可以根据需要调整
        }}>
            {fileList.map((filePath, index) => (
                <div key={index} style={{
                    width: `${wh}px`, // 每个文件项的固定宽度
                    height: `${wh}px`, // 固定高度
                    flex: 'none', 
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden', // 超出隐藏
                }}

                    icon={<DownloadOutlined />}
                    size="small">
                    {renderFileItem(filePath)}
                </div>
            ))}
        </div>
    );
};

export default renderFileList;